import styled, { device } from "@theme/utils";

export const BlogDetailsArea = styled.section`
    padding: 60px 0;
    ${device.medium} {
        padding: 80px 0;
    }
    ${device.large} {
        padding: 80px 0;
    }
    ${device.xlarge} {
        padding: 80px 0;
    }
`;

export const BlogPostContentArea = styled.div`
    ${device.large} {
        padding-right: 50px;
    }
`;
export const PostTitleArea = styled.div`
    margin-bottom: 30px;
`;
export const PostTitle = styled.h3``;
